<template>
  <div class="payment-data-wrapper" v-loading.fullscreen.lock="loading">
    <!-- 游戏选择 -->
    <div class="game-selector">
      <el-select v-model="currentGameId" placeholder="选择游戏" @change="onGameSelect" filterable style="width: 300px;">
        <el-option v-for="g in allGames" :key="g.id" :label="g.title" :value="g.id" />
      </el-select>
    </div>

    <!-- 筛选区域 -->
    <div class="filter-section">
      <el-card shadow="hover">
        <div class="filter-content">
          <div class="filter-item">
            <label class="filter-label">开始日期：</label>
            <el-date-picker
              v-model="startDate"
              type="date"
              placeholder="选择开始日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 150px;"
            />
          </div>
          <div class="filter-item">
            <label class="filter-label">结束日期：</label>
            <el-date-picker
              v-model="endDate"
              type="date"
              placeholder="选择结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 150px;"
            />
          </div>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </div>
      </el-card>
    </div>

    <!-- 用户看视频数据 -->
    <div class="result-section">
      <h3 class="section-title">用户看视频数据</h3>
      <el-table :data="videoSummaryData" style="width: 100%" border>
        <el-table-column prop="new_devices" label="新增设备数" width="100" />
        <el-table-column prop="new_users" label="新增用户数" width="100" />
        <el-table-column label="注册率" width="80">
          <template slot-scope="scope">{{ formatPercent(scope.row.register_rate) }}</template>
        </el-table-column>
        <el-table-column prop="watched_users" label="看过视频用户数" width="130" />
        <el-table-column prop="completed_1" label="看完1个" width="90" />
        <el-table-column prop="completed_2" label="看完2个" width="90" />
        <el-table-column prop="completed_3" label="看完3个" width="90" />
        <el-table-column prop="completed_4" label="看完4个" width="90" />
        <el-table-column prop="completed_5" label="看完5个" width="90" />
        <el-table-column prop="completed_6" label="看完6个" width="90" />
        <el-table-column prop="completed_7" label="看完7个" width="90" />
        <el-table-column prop="completed_8" label="看完8个" width="90" />
        <el-table-column prop="completed_9" label="看完9个" width="90" />
        <el-table-column prop="completed_10" label="看完10个" width="90" />
      </el-table>
    </div>

    <!-- 用户看视频数据-分天 -->
    <div class="result-section">
      <h3 class="section-title">用户看视频数据-分天</h3>
      <el-table :data="videoByDateData" style="width: 100%" border max-height="300">
        <el-table-column prop="date" label="日期" width="100" fixed />
        <el-table-column prop="new_devices" label="新增设备数" width="100" />
        <el-table-column prop="new_users" label="新增用户数" width="100" />
        <el-table-column label="注册率" width="80">
          <template slot-scope="scope">{{ formatPercent(scope.row.register_rate) }}</template>
        </el-table-column>
        <el-table-column prop="watched_users" label="看过视频" width="90" />
        <el-table-column prop="completed_1" label="看完1个" width="80" />
        <el-table-column prop="completed_2" label="看完2个" width="80" />
        <el-table-column prop="completed_3" label="看完3个" width="80" />
        <el-table-column prop="completed_4" label="看完4个" width="80" />
        <el-table-column prop="completed_5" label="看完5个" width="80" />
        <el-table-column prop="completed_6" label="看完6个" width="80" />
        <el-table-column prop="completed_7" label="看完7个" width="80" />
        <el-table-column prop="completed_8" label="看完8个" width="80" />
        <el-table-column prop="completed_9" label="看完9个" width="80" />
        <el-table-column prop="completed_10" label="看完10个" width="80" />
      </el-table>
    </div>

    <!-- 用户总充值数据 -->
    <div class="result-section">
      <h3 class="section-title">用户总充值数据</h3>
      <el-table :data="rechargeSummaryData" style="width: 100%" border>
        <el-table-column prop="new_devices" label="新增设备数" width="100" />
        <el-table-column prop="new_users" label="新增用户数" width="100" />
        <el-table-column label="注册率" width="80">
          <template slot-scope="scope">{{ formatPercent(scope.row.register_rate) }}</template>
        </el-table-column>
        <el-table-column prop="recharged_users" label="充值用户数" width="100" />
        <el-table-column prop="amount_2" label="充值>=2元" width="100" />
        <el-table-column prop="amount_5" label="充值>=5元" width="100" />
        <el-table-column prop="amount_10" label="充值>=10元" width="100" />
        <el-table-column prop="amount_20" label="充值>=20元" width="100" />
        <el-table-column prop="amount_30" label="充值>=30元" width="100" />
        <el-table-column prop="amount_50" label="充值>=50元" width="100" />
        <el-table-column prop="amount_100" label="充值>=100元" width="110" />
      </el-table>
    </div>

    <!-- 用户总充值数据-分天 -->
    <div class="result-section">
      <h3 class="section-title">用户总充值数据-分天</h3>
      <el-table :data="rechargeByDateData" style="width: 100%" border max-height="300">
        <el-table-column prop="date" label="日期" width="100" fixed />
        <el-table-column prop="new_devices" label="新增设备数" width="100" />
        <el-table-column prop="new_users" label="新增用户数" width="100" />
        <el-table-column label="注册率" width="80">
          <template slot-scope="scope">{{ formatPercent(scope.row.register_rate) }}</template>
        </el-table-column>
        <el-table-column prop="recharged_users" label="充值用户数" width="100" />
        <el-table-column prop="amount_2" label=">=2元" width="80" />
        <el-table-column prop="amount_5" label=">=5元" width="80" />
        <el-table-column prop="amount_10" label=">=10元" width="80" />
        <el-table-column prop="amount_20" label=">=20元" width="80" />
        <el-table-column prop="amount_30" label=">=30元" width="80" />
        <el-table-column prop="amount_50" label=">=50元" width="80" />
        <el-table-column prop="amount_100" label=">=100元" width="90" />
      </el-table>
    </div>

    <!-- 用户微信充值数据 -->
    <div class="result-section">
      <h3 class="section-title">用户微信充值数据</h3>
      <el-table :data="wechatSummaryData" style="width: 100%" border>
        <el-table-column prop="new_devices" label="新增设备数" width="100" />
        <el-table-column prop="new_users" label="新增用户数" width="100" />
        <el-table-column label="注册率" width="80">
          <template slot-scope="scope">{{ formatPercent(scope.row.register_rate) }}</template>
        </el-table-column>
        <el-table-column prop="recharged_users" label="充值用户数" width="100" />
        <el-table-column prop="amount_2" label="充值>=2元" width="100" />
        <el-table-column prop="amount_5" label="充值>=5元" width="100" />
        <el-table-column prop="amount_10" label="充值>=10元" width="100" />
        <el-table-column prop="amount_20" label="充值>=20元" width="100" />
        <el-table-column prop="amount_30" label="充值>=30元" width="100" />
        <el-table-column prop="amount_50" label="充值>=50元" width="100" />
        <el-table-column prop="amount_100" label="充值>=100元" width="110" />
      </el-table>
    </div>

    <!-- 用户微信充值数据-分天 -->
    <div class="result-section">
      <h3 class="section-title">用户微信充值数据-分天</h3>
      <el-table :data="wechatByDateData" style="width: 100%" border max-height="300">
        <el-table-column prop="date" label="日期" width="100" fixed />
        <el-table-column prop="new_devices" label="新增设备数" width="100" />
        <el-table-column prop="new_users" label="新增用户数" width="100" />
        <el-table-column label="注册率" width="80">
          <template slot-scope="scope">{{ formatPercent(scope.row.register_rate) }}</template>
        </el-table-column>
        <el-table-column prop="recharged_users" label="充值用户数" width="100" />
        <el-table-column prop="amount_2" label=">=2元" width="80" />
        <el-table-column prop="amount_5" label=">=5元" width="80" />
        <el-table-column prop="amount_10" label=">=10元" width="80" />
        <el-table-column prop="amount_20" label=">=20元" width="80" />
        <el-table-column prop="amount_30" label=">=30元" width="80" />
        <el-table-column prop="amount_50" label=">=50元" width="80" />
        <el-table-column prop="amount_100" label=">=100元" width="90" />
      </el-table>
    </div>

    <!-- 用户支付宝充值数据 -->
    <div class="result-section">
      <h3 class="section-title">用户支付宝充值数据</h3>
      <el-table :data="alipaySummaryData" style="width: 100%" border>
        <el-table-column prop="new_devices" label="新增设备数" width="100" />
        <el-table-column prop="new_users" label="新增用户数" width="100" />
        <el-table-column label="注册率" width="80">
          <template slot-scope="scope">{{ formatPercent(scope.row.register_rate) }}</template>
        </el-table-column>
        <el-table-column prop="recharged_users" label="充值用户数" width="100" />
        <el-table-column prop="amount_2" label="充值>=2元" width="100" />
        <el-table-column prop="amount_5" label="充值>=5元" width="100" />
        <el-table-column prop="amount_10" label="充值>=10元" width="100" />
        <el-table-column prop="amount_20" label="充值>=20元" width="100" />
        <el-table-column prop="amount_30" label="充值>=30元" width="100" />
        <el-table-column prop="amount_50" label="充值>=50元" width="100" />
        <el-table-column prop="amount_100" label="充值>=100元" width="110" />
      </el-table>
    </div>

    <!-- 用户支付宝充值数据-分天 -->
    <div class="result-section">
      <h3 class="section-title">用户支付宝充值数据-分天</h3>
      <el-table :data="alipayByDateData" style="width: 100%" border max-height="300">
        <el-table-column prop="date" label="日期" width="100" fixed />
        <el-table-column prop="new_devices" label="新增设备数" width="100" />
        <el-table-column prop="new_users" label="新增用户数" width="100" />
        <el-table-column label="注册率" width="80">
          <template slot-scope="scope">{{ formatPercent(scope.row.register_rate) }}</template>
        </el-table-column>
        <el-table-column prop="recharged_users" label="充值用户数" width="100" />
        <el-table-column prop="amount_2" label=">=2元" width="80" />
        <el-table-column prop="amount_5" label=">=5元" width="80" />
        <el-table-column prop="amount_10" label=">=10元" width="80" />
        <el-table-column prop="amount_20" label=">=20元" width="80" />
        <el-table-column prop="amount_30" label=">=30元" width="80" />
        <el-table-column prop="amount_50" label=">=50元" width="80" />
        <el-table-column prop="amount_100" label=">=100元" width="90" />
      </el-table>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import request from '@/utils/request'
import { Game, getGames } from '@/api/game'

interface DataRow {
  [key: string]: number | string | undefined
}

@Component
export default class PaymentDataAnalysis extends Vue {
  @Prop() readonly game!: Game

  allGames: Game[] = []
  currentGameId: number | null = null

  loading = false
  startDate = ''
  endDate = ''
  videoSummaryData: DataRow[] = []
  videoByDateData: DataRow[] = []
  rechargeSummaryData: DataRow[] = []
  rechargeByDateData: DataRow[] = []
  wechatSummaryData: DataRow[] = []
  wechatByDateData: DataRow[] = []
  alipaySummaryData: DataRow[] = []
  alipayByDateData: DataRow[] = []

  get selectedGame(): Game | null {
    if (this.currentGameId) {
      const found = this.allGames.find(g => g.id === this.currentGameId)
      if (found) return found
    }
    return this.game || null
  }

  @Watch('game', { immediate: true })
  onGamePropChange(newGame: Game) {
    if (newGame && newGame.id) {
      this.currentGameId = newGame.id
    }
  }

  async created() {
    const today = new Date()
    this.startDate = this.formatDate(today)
    this.endDate = this.formatDate(today)
    await this.loadAllGames()
    if (this.currentGameId) {
      this.handleSearch()
    }
  }

  async loadAllGames() {
    try {
      this.allGames = await getGames()
    } catch {
      // ignore
    }
  }

  onGameSelect(gameId: number) {
    this.currentGameId = gameId
    this.handleSearch()
  }

  formatDate(date: Date): string {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  formatPercent(value: number | undefined): string {
    if (value === undefined || value === null) return '-'
    return (value * 100).toFixed(1) + '%'
  }

  async handleSearch() {
    if (!this.currentGameId) {
      this.$message.warning('请先选择游戏')
      return
    }
    this.loading = true
    try {
      const params: Record<string, string | number> = {
        game_id: this.currentGameId,
        start_date: this.startDate,
        end_date: this.endDate
      }
      const res = await request.get('/api/payment_data_analysis', { params })
      if (res.data && res.data.data) {
        const data = res.data.data
        this.videoSummaryData = data.video_summary ? [data.video_summary] : []
        this.videoByDateData = data.video_by_date || []
        this.rechargeSummaryData = data.recharge_summary ? [data.recharge_summary] : []
        this.rechargeByDateData = data.recharge_by_date || []
        this.wechatSummaryData = data.wechat_summary ? [data.wechat_summary] : []
        this.wechatByDateData = data.wechat_by_date || []
        this.alipaySummaryData = data.alipay_summary ? [data.alipay_summary] : []
        this.alipayByDateData = data.alipay_by_date || []
      }
    } catch (error) {
      console.error('获取付费数据失败:', error)
      this.$message.error('获取数据失败')
    } finally {
      this.loading = false
    }
  }

  handleReset() {
    const today = new Date()
    this.startDate = this.formatDate(today)
    this.endDate = this.formatDate(today)
    this.handleSearch()
  }
}
</script>

<style scoped>
.payment-data-wrapper {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.game-selector {
  margin-bottom: 16px;
}

.filter-section {
  margin-bottom: 20px;
}

.filter-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;
}

.filter-item {
  display: flex;
  align-items: center;
}

.filter-label {
  margin-right: 8px;
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

.result-section {
  margin-bottom: 20px;
  background: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.section-title {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  border-left: 4px solid #409eff;
  padding-left: 10px;
}

::v-deep .el-table th {
  background-color: #f5f7fa;
}
</style>
